<!-- layout.component.html -->

<mat-sidenav-container class="admin-container">
  <mat-sidenav [mode]="sidebarMode" [opened]="sidebarOpened" class="sidebar">
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-topbar (toggleSidebarEvent)="toggleSidebar()"></app-topbar>

    <main class="main-content">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>